import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'
import { payMCopyDateStatusInversed } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import { useCallback } from 'react'
import { ButtonSecondary } from '../../../../../../../../../baseComponents/Button'
import CustomError from '../../../../../../../../../baseComponents/CustomError'
import { TwinIconToolTip } from '../../../../../../../../../baseComponents/TwinIcon'
import { RowData } from '../../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { SetOrderPaymentMethodModalTy } from '../types'

interface ErrorTotalPaymentMethodProps extends ErrorTotalPaymentMethodLogicProps {
    notMatchTotals: boolean
    className?: string
}

export const ErrorTotalPaymentMethod: React.FC<ErrorTotalPaymentMethodProps> = ({ notMatchTotals, className, ...logic }) => {
    const {t} = useTwinTranslation()
    const { handleRecalculateAllQuantity } = useErrorTotalPaymentMethodLogic({ ...logic })
    if(!notMatchTotals){
        return null
    }
    return (
        <div className={'flex items-center gap-x-60 ' + (className || '')}>
            <CustomError textError={t('totalSellInvoiceNotMatchTotalPaymentMethod', 'El total de la factura no coincide con el total del método de pago')} />
            <ButtonSecondary onClick={handleRecalculateAllQuantity}><TwinTrans transKey='recalculate'>Recalcular</TwinTrans></ButtonSecondary>
        </div>
    )
}

interface ErrorTotalPaymentMethodLogicProps {
    recalculateAllQuantity: () => void
}

const useErrorTotalPaymentMethodLogic = ({ recalculateAllQuantity }: ErrorTotalPaymentMethodLogicProps) => {
    const handleRecalculateAllQuantity: React.MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        recalculateAllQuantity()
    }, [recalculateAllQuantity])
    return { handleRecalculateAllQuantity }
}

interface MarkAsPaidPaymentMethodDateIconProps {
    allRowData: RowData
    setOpenModal: SetOrderPaymentMethodModalTy
}

export const MarkAsPaidPaymentMethodDateIcon: React.FC<MarkAsPaidPaymentMethodDateIconProps> = ({ allRowData, setOpenModal }) => {
    const { t } = useTwinTranslation()
    if (allRowData.status !== payMCopyDateStatusInversed['pending_send']) {
        return null
    }
    return (
        <TwinIconToolTip id={'markAsPaid' + String(allRowData?.id)} message={t('markAsPaid', 'Marcar como pagado')} icon={faCheckCircle} className='ml-auto' classNameIcon='w-18 h-18' onClick={() => setOpenModal({ type: 'markAsPaid', allRowData: allRowData || {} })} />
    )
}